(() => {
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]));
  document.querySelectorAll('[data-pcstation-search-root]').forEach(root => {
    const input = root.querySelector('[data-pcstation-search]');
    const output = root.querySelector('[data-pcstation-suggestions]');
    if (!input || !output || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    let timer, controller, version = 0;
    const rootUrl = window.Shopify?.routes?.root || '/';
    const allLink = term => {
      const url = new URL(rootUrl + 'search', window.location.href);
      url.searchParams.set('q', term);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      const current = new URLSearchParams(window.location.search);
      for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.has(key)) url.searchParams.set(key, current.get(key));
      return '<a class="pcstation-search-strip__view-all" href="' + escapeHtml(url.href) + '">' + escapeHtml(root.dataset.viewAll) + ' →</a>';
    };
    const show = html => {
      output.innerHTML = html;
      output.hidden = false;
    };
    const status = (text, term, loading = false) => {
      output.setAttribute('aria-busy', String(loading));
      show('<p class="pcstation-search-strip__status" role="status">' + escapeHtml(text) + '</p>' + (loading ? '' : allLink(term)));
    };
    const dismiss = () => {
      version++;
      window.clearTimeout(timer);
      controller?.abort();
      output.hidden = true;
      output.innerHTML = '';
      output.setAttribute('aria-busy', 'false');
    };
    input.addEventListener('input', () => {
      dismiss();
      const term = input.value.trim(), currentVersion = version;
      if (term.length < 2) return;
      status(root.dataset.loading, term, true);
      timer = window.setTimeout(async () => {
        const request = new AbortController();
        controller = request;
        const timeout = window.setTimeout(() => request.abort(), 8000);
        try {
          const params = new URLSearchParams({q:term, 'resources[type]':'product', 'resources[limit]':'6', 'resources[options][unavailable_products]':'show'});
          const response = await window.fetch(rootUrl + 'search/suggest.json?' + params, {credentials:'same-origin', signal:request.signal, headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Search request failed');
          const data = await response.json();
          if (version !== currentVersion || input.value.trim() !== term) return;
          const products = data?.resources?.results?.products;
          if (!Array.isArray(products)) throw new Error('Invalid search response');
          if (!products.length) { status(root.dataset.empty, term); return; }
          const rows = products.map(product => {
            const imageUrl = product.featured_image?.url || product.featured_image || product.image?.url || product.image || '';
            const image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy" width="80" height="80">' : '<span class="pcstation-search-strip__suggestion-image"></span>';
            const url = product.url || rootUrl + 'products/' + product.handle;
            const price = Number(product.price);
            const formatted = Number.isFinite(price) ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(price) : '';
            return '<a class="pcstation-search-strip__suggestion" href="' + escapeHtml(url) + '">' + image + '<strong>' + escapeHtml(product.title) + '</strong><span>' + escapeHtml(formatted) + '</span></a>';
          }).join('');
          output.setAttribute('aria-busy', 'false');
          show(rows + allLink(term));
        } catch (error) {
          if (version === currentVersion && input.value.trim() === term) status(root.dataset.error, term);
        } finally {
          window.clearTimeout(timeout);
        }
      }, 160);
    });
    root.querySelector('form')?.addEventListener('reset', dismiss);
    if (root.matches('form')) root.addEventListener('reset', dismiss);
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') { dismiss(); input.focus(); return; }
      if (output.hidden || !['ArrowDown','ArrowUp'].includes(event.key)) return;
      const links = [...output.querySelectorAll('a')], index = links.indexOf(document.activeElement);
      if (!links.length || (document.activeElement !== input && index < 0)) return;
      event.preventDefault();
      const next = index < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : Math.max(0, Math.min(links.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)));
      links[next].focus();
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) dismiss(); });
    root.closest('details')?.addEventListener('toggle', event => { if (!event.target.open) dismiss(); });
  });
})();
